import React from 'react';
import {FormFieldConfigSize} from '@src/@types/components/Form';

export default function ImageAttach(props: {
    src?: string,
    alt?: string,
    onClick?: React.MouseEventHandler<HTMLImageElement>,
    size?: FormFieldConfigSize,
}) {
    return props.src ? <img
            src={props.src}
            alt={props.alt}
            onClick={props.onClick}
            className="file-representation--image"
    /> : null;
}
